module.exports = __webpack_public_path__ + "img/image56.8adc8017.png";